import React from "react";
import Option from "@ui/Option";
import { DownloadLine } from "@ui/IconV2/react";
import { color } from "@ui";
import t from "../../../../i18n";
import useExportSetupArtifact, { type SetupExportSection } from "./useExportSetupArtifact";

export default function ExportArtifactOption({
  projectId,
  setupId,
  section,
}: {
  projectId: string;
  setupId: string;
  section: SetupExportSection;
}) {
  const { exportArtifact, loading } = useExportSetupArtifact(projectId, setupId, section);
  return (
    <Option closeOnClick onClick={exportArtifact} disabled={loading}>
      <DownloadLine color={color.carbon800} />
      {t("commons.message_card.export")}
    </Option>
  );
}
